export default {
  accountInfo: (state) => state.accountInfo,
  logged: (state) => state.logged,
  language: (state) => state.language,
};
